<div>
    <div class="fs-4 fw-semibold mb-3">{{'searchlimit' | translate}}</div>
    <div class="row mb-4">
        <div class="col-md-6 col-lg-4 mb-2">
          <div class="d-flex align-items-center search gap-2 w-100">
              <input #searchInput  pInputText id="search-card"
                  [placeholder]="'enterlimit' | translate" />
              <button class="btn searchBtn">
                  <i class="pi pi-search"></i>
              </button>
          </div>
      </div>
    </div>
</div>
<div  class="d-flex justify-content-center align-items-center">
    <img src="../../assets/nodataavailable.png" alt="">
</div>
